import z from 'zod'
import { normalizeEmail } from '../utils/normalize-email'

export const identityProviders = ['google', 'microsoft'] as const

export type IdentityProvider = (typeof identityProviders)[number]

const emailSchema = z
  .string()
  .min(1, 'Campo requerido')
  .email({
    message: 'Correo electrónico inválido',
  })
  .transform(normalizeEmail)

export const createAuthorizationURLRequestBody = z.object({
  idp: z.enum(identityProviders),
  invitationToken: z.string().nullish(),
})

export type CreateAuthorizationURLRequestBody = z.infer<
  typeof createAuthorizationURLRequestBody
>

export const createAuthorizationURLResponseBody = z.object({
  url: z.string(),
})

export type CreateAuthorizationURLResponseBody = z.infer<
  typeof createAuthorizationURLResponseBody
>

export const invitationTokenRequestQuery = z.object({
  token: z.string(),
})

export type InvitationTokenRequestQuery = z.infer<
  typeof invitationTokenRequestQuery
>

export const invitationTokenHeaderName = 'x-invitation-token'

export const retrieveMembershipFromInvitationRequestParams = z.object({
  membershipId: z.string(),
})

export const retrieveMembershipFromInvitationResponseBody = z.object({
  email: emailSchema,
  firstName: z.string(),
  lastName: z.string(),
  membershipId: z.string(),
  invitationToken: z.string(),
})

export type RetrieveMembershipFromInvitationResponseBody = z.infer<
  typeof retrieveMembershipFromInvitationResponseBody
>

export const registerEmailMembershipInvitationRequestParams = z.object({
  membershipId: z.string().min(1, 'Membership ID is required'),
})

export type RegisterEmailMembershipInvitationRequestParams = z.infer<
  typeof registerEmailMembershipInvitationRequestParams
>

export const registerEmailMembershipInvitationRequestBody = z.object({
  password: z.string().min(8, 'Mínimo 8 caracteres'),
})

export type RegisterEmailMembershipInvitationRequestBody = z.infer<
  typeof registerEmailMembershipInvitationRequestBody
>

export const registerEmailMembershipInvitationResponseBody = z.object({
  email: emailSchema,
  firstName: z.string(),
  lastName: z.string(),
})

export const loginBouncedRequestQuery = z.object({
  error_code: z.enum([
    'not_found_user',
    'invitation_email_mismatch',
    'user_resource_limit_reached',
    'idp_not_allowed',
    'invalid_id_token',
  ]),
  idp: z.enum(identityProviders).nullish(),
})

export type LoginBouncedRequestQuery = z.infer<typeof loginBouncedRequestQuery>

export const loginUserRequestBody = z.object({
  email: emailSchema,
  password: z.string(),
  remember: z.boolean().optional(),
})

export type LoginUserRequestBody = z.infer<typeof loginUserRequestBody>
